import {
  makeUrl,
  useAppLocation,
  useAnalytics,
  useAppNavigate,
  formatCurrency,
  UseProductCardLogicProps,
  normalizeUrl,
} from "../";

export const useProductCardLogic = ({
  product,
  locale,
  currency,
  storeMetadata,
}: UseProductCardLogicProps) => {
  const [logEvent] = useAnalytics({ storeMetadata });
  const navigate = useAppNavigate();
  const hasDiscount =
    !!product.priceWithDiscount && product.priceWithDiscount >= 0;
  const isWholesale =
    !!product.wholesale && product.wholesale.configurations?.length > 0;
  const isKit = !!product.kit && (product.products || []).length > 0;
  const isHighlight = !!product.highlight;
  const images =
    product?.imagesDetail || product?.images?.map((i) => ({ url: i })) || [];
  const percentageDiscount = product.percentageDiscount || 0;
  const withoutDiscountPrice = product.price || 0;
  const formattedWithoutDiscountPrice = formatCurrency(withoutDiscountPrice, {
    locale: locale,
    currency: currency,
  });
  const { pathname } = useAppLocation();

  const finalPrice = product.priceWithDiscount || product.price || 0;
  const formattedFinalPrice = formatCurrency(finalPrice, {
    locale: locale,
    currency: currency,
  });
  const urlProduct = makeUrl(
    pathname,
    `${!isKit ? "producto" : "combo"}/${
      normalizeUrl(product.friendlyUrl) || product.id
    }`,
  );

  const urlProductDetail = (source?: string) => {
    let url = urlProduct;
    if (!!source) url = `${pathname}/${urlProduct}?source_event=${source}`;

    return url;
  };

  const goToProductDetail = (source?: string): void => {
    let url = urlProductDetail(source);
    navigate(url, { relative: "path" });
  };

  return {
    hasDiscount,
    finalPrice,
    formattedFinalPrice,
    isWholesale,
    isHighlight,
    isKit,
    withoutDiscountPrice,
    formattedWithoutDiscountPrice,
    images,
    percentageDiscount,
    urlProduct,
    logEvent,
    goToProductDetail,
    urlProductDetail,
  };
};
